import { render, staticRenderFns } from "./selectGift.vue?vue&type=template&id=64d304f4&scoped=true"
import script from "./selectGift.vue?vue&type=script&lang=js"
export * from "./selectGift.vue?vue&type=script&lang=js"
import style0 from "./selectGift.vue?vue&type=style&index=0&id=64d304f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d304f4",
  null
  
)

export default component.exports